export default __webpack_public_path__ + "static/s10-5c7a51e635b3b195fd5e374c6779c464.jpg";